import { CONFERENCE_FAILED, CONFERENCE_JOINED, CONFERENCE_JOIN_IN_PROGRESS, CONFERENCE_WILL_LEAVE, KICKED_OUT } from '../../../../react/features/base/conference/actionTypes';
import { CONNECTION_WILL_CONNECT } from '../../../../react/features/base/connection/actionTypes';
import { JitsiConnectionEvents } from '../../../../react/features/base/lib-jitsi-meet';
import MiddlewareRegistry from '../../../../react/features/base/redux/MiddlewareRegistry';
import { saveDisconnectInfo } from './actions';
import { _bindConferenceConnectionListener, conferenceDispose, conferenceFailed, conferenceJoined, isKibanaLogsEnabled } from './functions';
/**
 * Implements the middleware of the feature base/devices.
 *
 * @param {Store} store - Redux store.
 * @returns {Function}
 */
// eslint-disable-next-line no-unused-vars
MiddlewareRegistry.register(store => next => action => {
    switch (action.type) {
        case CONFERENCE_JOIN_IN_PROGRESS:
            if (!isKibanaLogsEnabled(store.getState())) {
                break;
            }
            _bindConferenceConnectionListener(action.conference, store);
            break;
        case CONFERENCE_FAILED:
            if (!isKibanaLogsEnabled(store.getState())) {
                break;
            }
            return conferenceFailed(store, action, next);
        case CONFERENCE_JOINED: {
            if (!isKibanaLogsEnabled(store.getState())) {
                break;
            }
            return conferenceJoined(store, action, next);
        }
        case CONNECTION_WILL_CONNECT: {
            const { connection } = action;
            if (!isKibanaLogsEnabled(store.getState()) || !connection) {
                break;
            }
            connection.addEventListener(JitsiConnectionEvents.CONNECTION_FAILED, (status) => {
                store.dispatch(saveDisconnectInfo(status));
            });
            break;
        }
        case CONFERENCE_WILL_LEAVE:
        case KICKED_OUT: {
            if (!isKibanaLogsEnabled(store.getState())) {
                break;
            }
            return conferenceDispose(store, action, next);
        }
    }
    return next(action);
});
